import React, { Component } from 'react';
import Chart from "react-apexcharts";
import { postDashboardForm } from '../api/apiClient'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';
import { ROCELL_COLORS } from '../theme/rocellTheme';

export class LIOchart extends Component {
    constructor() {
        super()
        this.state = {
            data_record: [],
            isLoaded: false,
            filterSupplier: '',
            filterDateTo: '',
            filterDateFrom: '',
            suppliers: JSON.parse(localStorage.getItem('suppliers'))

        };
        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    // Helper to add days and format YYYY-MM-DD
    addDaysFormatted(dateStr, days) {
        if (!dateStr) return ''
        const d = new Date(dateStr + 'T00:00:00')
        d.setDate(d.getDate() + days)
        return d.toISOString().split('T')[0]
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        } else if (key == 'from') {
            // when from changes, if current 'to' is out of new allowed range, adjust it
            const newFrom = event.target.value
            const maxAllowedTo = this.addDaysFormatted(newFrom, 3) // 4-day range: from + 3 days
            this.setState((prevState) => {
                let newTo = prevState.filterDateTo
                if (newTo && newTo > maxAllowedTo) {
                    newTo = maxAllowedTo
                }
                return { filterDateFrom: newFrom, filterDateTo: newTo }
            })
        } else if (key == 'filterSupplier') {
            this.setState({ filterSupplier: event.target.value })
        }

    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const dataUrl = API_URL + "/Bi_dashboard_lio"

        postDashboardForm(dataUrl, formData).then((response) => {
            if (response.data.success) {
                const reportData = response.data.data;
                console.log(reportData);
                this.setState({ data_record: reportData })
                this.updateLoader(true)
            } else {
                console.log("No data returned from API")
                this.updateLoader(true)
            }
        }).catch(function (error) {
            console.log(error);
        });

    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    updateChart() {
        const newToDate = this.state.filterDateTo;
        const newFromDate = this.state.filterDateFrom;
        const filterSupplier = this.state.filterSupplier;

        // Validation: ensure range is <= 4 days
        if (newFromDate && newToDate) {
            const maxAllowedTo = this.addDaysFormatted(newFromDate, 3)
            if (newToDate > maxAllowedTo) {
                alert('Date range cannot exceed 4 days. Please select a To date within 4 days of From date.')
                return
            }
        }

        const formData = new FormData();
        formData.append('filter_date_from', newFromDate);
        formData.append('filter_date_to', newToDate);
        formData.append('supplier_id', filterSupplier);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();

        var currentDate = new Date();
        currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDateFrom = currentDate.toISOString().split('T')[0];

        currentDate = new Date();
        var formattedDateTo = currentDate.toISOString().split('T')[0];

        formData.append('filter_date_from', formattedDateFrom);
        formData.append('filter_date_to', formattedDateTo);
        formData.append('supplier_id', '7');
        this.setState({ filterDateFrom: formattedDateFrom })
        this.setState({ filterDateTo: formattedDateTo })
        this.setState({ filterSupplier: '7' })
        this.getData(formData);
    }

    render() {
        // Prepare export headers and data for Excel
        const exportHeaders = [
            { label: "Vehicle Number", key: "vehicle_no" },
            { label: "Geofence", key: "geofence_location" },
            { label: "In Time", key: "geofence_in_time" },
            { label: "Out Time (Gatepass print time)", key: "gate_pass_time" },
            { label: "TTA Time", key: "turnaround_time" },
            { label: "Shipment", key: "shipment_no" }
        ];
        const exportData = this.state.data_record.map(record => ({
            Vehicle: record?.vehicle_no,
            Geofence: record?.geofence_location,
            In: record?.geofence_in_time,
            Out: record?.gate_pass_time,
            TTAT: record?.turnaround_time,
            Shipment: record?.shipment_no,
        }));

        // compute max allowed 'to' date for the currently selected from date
        const maxToDate = this.state.filterDateFrom ? this.addDaysFormatted(this.state.filterDateFrom, 3) : ''

        return (
            <div className='card bi-chart-card'>
                <div className='card-header border-0'>
                    <div className='row align-items-center'>
                        <div className='col-lg-5'>
                            <p className='card-title mb-0'>
                                <span className='card-label fw-bold'>
                                    Location In & Out Time
                                    <span className='bi-date-muted d-block mt-1'>{this.state.filterDateFrom} to {this.state.filterDateTo}</span>
                                </span>
                            </p>
                        </div>
                        <div className='col-lg-7 bi-chart-actions mt-3 mt-lg-0'>
                            <button
                                type='button'
                                className='btn btn-sm btn-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'>
                                <i className='fas fa-filter me-1'></i> Filter
                            </button>
                            <ExcelExport
                                data={exportData}
                                headers={exportHeaders}
                                fileName={`Location_In_Out_${this.state.filterDateFrom}_to_${this.state.filterDateTo}`}
                            />
                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>
                                <div className='separator border-gray-200'></div>
                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter From Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateFrom}
                                                onChange={(event) => this.filterChange('from', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter To Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' max={maxToDate} />
                                        </div>
                                    </div>

                                    {/* <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter Supplier:</label>
                                        <div>

                                            <select name='suppliers' id='suppliers' className='form-control'
                                                value={this.state.filterSupplier}
                                                onChange={(event) => this.filterChange('filterSupplier', event)}>
                                                {this.state.suppliers.map((supplier) => (
                                                    <option key={supplier.sup_id} value={supplier.sup_id}>
                                                        {supplier.sup_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div> */}

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    {!this.state.isLoaded ? (
                        <div className='bi-chart-area'>
                            <Circles
                                height="80"
                                width="80"
                                color={ROCELL_COLORS.primary}
                                ariaLabel="circles-loading"
                                visible={true}
                            />
                        </div>
                    ) : (
                        <div className='bi-table-scroll'>
                            <table className='table table-bordered bi-data-table'>
                                <thead>
                                    <tr>
                                        <th className='text-center'>Vehicle Number</th>
                                        <th className='text-center'>Geofence</th>
                                        <th>In Time</th>
                                        <th>Out Time (Gatepass print time)</th>
                                        <th>TAT Time</th>
                                        <th>Shipment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data_record.map((record,idx) => (
                                        <tr key={record.idx}>
                                            <td>{record?.vehicle_no}</td>
                                            <td className='text-center'>{record?.geofence_location}</td>
                                            <td>{record?.geofence_in_time}</td>
                                            <td>{record?.gate_pass_time}</td>
                                            <td>{record?.turnaround_time}</td>
                                            <td>{record?.shipment_no}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
// 6c6d1a06d6eecaca2fb670453dd17afa756DA04C8B626CC4AEAC99F54A8BBA100C60399A